import type { AfterViewInit } from '@angular/core';
import { Directive, EventEmitter, Output } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AumDateInput } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import fastDeepEqual from 'fast-deep-equal';
import moment from 'moment';
import { distinctUntilChanged } from 'rxjs';
@UntilDestroy()
@Directive({
    selector: '[aumicoBalanceSheetCurrentFormControlChangeListener]',
})
export class BalanceSheetCurrentDateChangeListenerDirective implements AfterViewInit {
    @Output() balanceSheetCurrentDateValueChange = new EventEmitter<moment.Moment>();
    constructor(private readonly aumDateInput: AumDateInput) {}
    ngAfterViewInit(): void {
        const balanceSheetFormControl = this.aumDateInput.aumFormControl;
        balanceSheetFormControl.valueChanges
            .pipe(
                distinctUntilChanged((previousFormChanges, currentFormChanges) =>
                    fastDeepEqual(moment(previousFormChanges), moment(currentFormChanges)),
                ),
                untilDestroyed(this),
            )
            .subscribe((currentFormChanges) => {
                if (balanceSheetFormControl.value == null) return;
                if (!balanceSheetFormControl.dirty) return;

                this.balanceSheetCurrentDateValueChange.emit(currentFormChanges as moment.Moment);
            });
    }
}
